import * as React from 'react';

class UnauthorizeAccessPage extends React.Component {
  render() {
    return <div>Unauthorize page access, try refreshing the page or log in again.</div>;
  }
}

export default UnauthorizeAccessPage;
